import React from "react";
import LaboratoryComponents from "../components/laboratory/LaboratoryComponents";

const LaboratoryPage = () => {
  return <LaboratoryComponents />;
};

export default LaboratoryPage;
